<template>
  <div
    class="confirm-dropdown open"
    :class="{
      'confirm__status-info':
        (lesson_status_id !== 6 && confirmed_state == 3) ||
        (lesson_status_id !== 6 && confirmed_state == 3)
    }"
    @click="viewDrop = !viewDrop"
    v-if="lesson_status_id !== 6"
  >
    <div
      class="confirm-dropdown__current"
      v-if="confirmed_state == 1 || confirmed_state == 3"
      :class="{ like: confirmed_state == 1 }"
    >
      <icon name="like-icon" />
      <span v-if="confirmed_state == 1"
        >{{ confimedUser.name ? confimedUser.name : '-' }}
        {{ confimedUser.last_name ? confimedUser.last_name : '' }}
      </span>
    </div>
    <div
      class="confirm-dropdown__current"
      :class="{ dislike: confirmed_state == 2 }"
      v-if="confirmed_state == 2 || confirmed_state == 3"
    >
      <icon name="dislike-icon" />
      <span v-if="confirmed_state == 2"
        >{{ confimedUser.name ? confimedUser.name : '-' }}
        {{ confimedUser.last_name ? confimedUser.last_name : '' }}
      </span>
    </div>
    <ul class="confirm-dropdown__list" v-if="viewDrop">
      <li
        :class="{ 'confirm__status-succes_stroke': confirmed_state == 1 }"
        @click="changeLessonConfirm(1)"
      >
        <icon name="like-icon" />מאושר
      </li>
      <li
        :class="{ 'confirm__status-error_stroke': confirmed_state == 2 }"
        @click="changeLessonConfirm(2)"
      >
        <icon name="dislike-icon" />לא מאושר
      </li>
      <li
        :class="{ 'confirm__status-neitrall_stroke': confirmed_state == 3 }"
        @click="changeLessonConfirm(3)"
      >
        <icon name="new-circle-close-transparent-icon" />הסר בחירה
      </li>
    </ul>
  </div>
  <div class="confirm-dropdown confirm__status-info" v-else></div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    confirm: {
      type: [Number, String],
      require: true
    },
    lesson_id: {
      type: [Number, String]
    },
    lesson_status_id: {
      type: [Number, String]
    },
    lesson_status_confirm_fill_user_name: {
      type: String,
      require: false
    },
    lesson_status_confirm_fill_user_last_name: {
      type: String,
      require: false
    }
  },
  data() {
    return {
      viewDrop: false,
      confirmed_state: this.confirm,
      confirmed_click: false
    };
  },

  computed: {
    ...mapGetters({ user: 'auth/user' }),
    confimedUser() {
      if (this.confirmed_click) {
        return { name: this.user.name, last_name: this.user.last_name };
      }
      if (
        this.lesson_status_confirm_fill_user_name &&
        this.lesson_status_confirm_fill_user_last_name &&
        !this.confirmed_click
      ) {
        return {
          name: this.lesson_status_confirm_fill_user_name,
          last_name: this.lesson_status_confirm_fill_user_last_name
        };
      } else {
        return '';
      }
    }
  },
  watch: {
    confirm(val) {
      this.confirmed_state = val;
    }
  },
  methods: {
    changeLessonConfirm(confirm) {
      this.confirmed_click = true;
      this.confirmed_state = confirm;
      this.$emit(
        'changeLessonConfirm',
        confirm,
        this.lesson_id,
        this.lesson_status_id
      );
    }
  }
};
</script>

<style scoped lang="scss">
.confirm__status-info {
  display: flex;
  justify-content: center;
}
.confirm__status-succes_stroke {
  stroke: #29cc44 !important;
  background: #eaffee !important;
  color: #29cc44 !important;
}
.confirm__status-error_stroke {
  stroke: #ff6052 !important;
  background: #fff5f4 !important;
  color: #ff6052 !important;
}
.confirm__status-neitrall_stroke {
  background: #e3e7ee;
}
.confirm-dropdown {
  position: relative;
  flex-shrink: 0;
  &__current {
    font-size: 14px;
    line-height: 20px;
    color: #38455d;
    display: flex;
    // align-items: center;
    align-items: flex-end;
    text-align: right;
    gap: 8px;
    stroke: #38455d;
    cursor: pointer;
    &.like {
      stroke: #29cc44;
    }
    &.dislike {
      stroke: #ff6052;
    }
  }
  &__list {
    position: absolute;
    top: 24px;
    z-index: 1;
    right: -12px;
    // width: 100%;
    min-width: 160px;
    background: #ffffff;
    box-shadow: 0px 8px 20px -4px rgba(56, 69, 93, 0.08),
      0px 4px 12px -4px rgba(56, 69, 93, 0.04);
    border-radius: 12px;
    padding: 8px 0;
    pointer-events: none;
    transition: 0.3s;
    cursor: pointer;
    &.list_icom {
      &.like {
        stroke: #29cc44;
      }
      &.dislike {
        stroke: #ff6052;
      }
    }
    li {
      padding: 8px 12px;
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 14px;
      line-height: 24px;
      color: #38455d;
      cursor: pointer;
      transition: 0.3s;
      stroke: #38455d;
      &:hover {
        &:nth-child(1) {
          stroke: #29cc44;
          background: #eaffee;
        }
        &:nth-child(2) {
          stroke: #ff6052;
          background: #fff5f4;
        }
        &:nth-child(3) {
          background: #e3e7ee;
        }
      }

      svg {
        path {
          transition: 0.3s;
          stroke: #38455d;
        }
      }
    }
  }
  &.open {
    .confirm-dropdown {
      &__list {
        opacity: 1;
        pointer-events: all;
      }
    }
  }
}
</style>
<style></style>
